<div class="content" [ngClass]="userService.isRas ? 'rasContent' : ''">
  <h2 class="title">{{ isEditing ? Texts.editTitle : Texts.title }}</h2>
  <mat-icon class="close-modal" (click)="closeModal()">close</mat-icon>
  <form [formGroup]="form" class="selectRasForms">
    <div class="row">
      <div
        class="col-6 margTop"
        [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
      >
        <mat-form-field appearance="outline">
          <mat-label>Tipo de caso</mat-label>
          <mat-select formControlName="caseType" (selectionChange)="findUser()">
            <mat-option
              *ngFor="let caseType of caseTypes"
              [value]="caseType._id"
              >{{ caseType.name }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="col-6 margTop"
        [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
      >
        <mat-form-field appearance="outline">
          <mat-label>Asignado a</mat-label>
          <mat-select formControlName="assigned">
            <mat-option *ngFor="let user of users" [value]="user._id">
              {{ user.data.nm ? "NM:" + user.data.nm : "" }}
              {{ user.fullname }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div
        class="col-12 margTop"
        [ngClass]="userService.isRas ? 'contentRasSelectorForms' : ''"
      >
        <mat-form-field appearance="outline">
          <mat-label>{{
            unit?.code != "LDC" ? "Descripción" : "Tipología"
          }}</mat-label>
          <textarea matInput formControlName="description"></textarea>
        </mat-form-field>
      </div>
    </div>
    <ras-form
      [caseType]="caseType"
      [caseTypes]="caseTypes"
      [caseId]="caseId"
      [createCase]="createCase"
      [caseInfo]="data.case"
      (formValid)="additionalFormValidChange($event)"
    ></ras-form>
    <case-files
      [(files)]="files"
      [(newFiles)]="newFiles"
      [(deleteFiles)]="deleteFiles"
      [isEditing]="isEditing"
    ></case-files>
  </form>

  <div class="button">
    <button
      mat-raised-button
      class="primary-btn rounded"
      [disabled]="!form.valid || isLoading || !additionalFormValid"
      (click)="save()"
      [ngClass]="userService.isRas ? 'buttonRas' : ''"
    >
      {{ isEditing ? Texts.edit : Texts.create }}
    </button>
  </div>
</div>
